export const isOnline = () => {
    // return false
    return navigator.onLine
}